const getOrCreateVisitorId = () => {
  const key = 'ss_visitor_id';
  const existing = localStorage.getItem(key);
  if (existing) return existing;

  let id = '';
  try {
    const bytes = new Uint8Array(16);
    window.crypto.getRandomValues(bytes);
    id = Array.from(bytes)
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
  } catch (_) {
    id = `${Date.now()}-${Math.random().toString(16).slice(2)}`;
  }
  id = `v_${id}`.slice(0, 64);
  localStorage.setItem(key, id);
  return id;
};

const normalizePathForAnalytics = (path) => {
  const raw = String(path || '').trim();
  if (!raw) return '/';
  const withoutQuery = raw.split('?')[0].split('#')[0];
  const parts = withoutQuery
    .split('/')
    .filter(Boolean)
    .map((seg) => {
      if (/^\d+$/.test(seg)) return ':id';
      if (/^[0-9a-f]{8,}$/i.test(seg)) return ':id';
      return seg.slice(0, 64);
    });
  return `/${parts.join('/')}`.slice(0, 255);
};

let lastSent = { path: '', at: 0 };

export const trackWebVisit = async ({ path, referrer } = {}) => {
  const normalizedPath = normalizePathForAnalytics(path || window.location.pathname);
  const now = Date.now();
  if (lastSent.path === normalizedPath && now - lastSent.at < 3000) return;
  lastSent = { path: normalizedPath, at: now };

  const visitorId = getOrCreateVisitorId();
  const token = localStorage.getItem('token');
  const payload = JSON.stringify({
    path: normalizedPath,
    visitorId,
    referrer: referrer || document.referrer || null,
  });

  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([payload], { type: 'application/json' });
      navigator.sendBeacon('/api/analytics/web-visit', blob);
      return;
    }
  } catch (_) {}

  try {
    await fetch('/api/analytics/web-visit', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      },
      body: payload,
      keepalive: true,
    });
  } catch (_) {
    // Best-effort only.
  }
};

